var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:['box-section', { 'has-title': _vm.title }]},[(_vm.title)?_c('div',{staticClass:"box-section-header"},[_c('h2',{staticClass:"box-section-title headline-m"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_c('div',{staticClass:"box-section-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }